/**
 * HomeRedirect Component
 *
 * Simple redirect for the root "/" route:
 * - Logged out users → /login
 * - Logged in users → /climb (map view with Apex)
 */

import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { PageLoader } from '@/components/ui';

export const HomeRedirect = () => {
  const { user, loading } = useAuth();

  // Show loader while auth is loading
  if (loading) {
    return <PageLoader message="Loading..." />;
  }

  // Not logged in → login page
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // All users go to climb page (map view with Apex)
  return <Navigate to="/climb?view=map" replace />;
};

export default HomeRedirect;
